import { rawDynamicImport } from '@app/helpers/memberships/section'
import { data } from '@app/memberships/state/store';
import { computed } from 'vue'

const individualValidationRules = {
    'individual.title'                                   : ['required'],
    'individual.other_title'                             : ['required_if:individual.title.value,other'],
    'individual.forename'                                : ['required'],
    'individual.surname'                                 : ['required'],
    'individual.how_did_you_hear_about_us_other'         : ['required_if:individual.how_did_you_hear_about_us.value,other'],
    'individual.consents_to_data_processing_and_storage' : ['required'],
}

const organisationValidationRules = {
    'organisation.name'                                    : ['required'],
    'organisation.how_did_you_hear_about_us_other'         : ['required_if:organisation.how_did_you_hear_about_us.value,other'],
    'organisation.consents_to_data_processing_and_storage' : ['required', 'checked'],
}

export default function(validate, form){
    const isOrganisationMembership = computed(
        () => data.membership_type.is_organisation_membership.value
    )

    const isValidIndividual = computed(
        () => data.user.is_individual_member.value
            || validate(individualValidationRules)
    )

    const isValidOrganisation = computed(
        () => data.user.is_organisation_member.value
            || validate(organisationValidationRules)
    )

    return {
        title     : computed(
            () => isOrganisationMembership.value
                ? 'Organisation details'
                : 'Personal details'
        ),
        component : rawDynamicImport(() => import('@app/memberships/components/form/stages/company_details/CompanyDetails.vue')),
        isValid   : computed(
            () => isOrganisationMembership.value
                ? isValidOrganisation.value
                : isValidIndividual.value
        ),
        data: computed(
            () => isOrganisationMembership.value
                ? {
                    organisation: {
                        name                                    : form.value.organisation?.name,
                        how_did_you_hear_about_us               : form.value.organisation?.how_did_you_hear_about_us?.value,
                        how_did_you_hear_about_us_other         : form.value.organisation?.how_did_you_hear_about_us_other,
                        consents_to_data_processing_and_storage : form.value.organisation?.consents_to_data_processing_and_storage,
                    }
                } : {
                    individual: {
                        title                                   : form.value.individual?.title?.value,
                        other_title                             : form.value.individual?.other_title,
                        forename                                : form.value.individual?.forename,
                        middle_name                             : form.value.individual?.middle_name,
                        surname                                 : form.value.individual?.surname,
                        how_did_you_hear_about_us               : form.value.individual?.how_did_you_hear_about_us?.value,
                        how_did_you_hear_about_us_other         : form.value.individual?.how_did_you_hear_about_us_other,
                        consents_to_data_processing_and_storage : form.value.individual?.consents_to_data_processing_and_storage,
                        
                    }
                }
        ),
        onReloadData : (progression) => {
            form.value.organisation = progression.data.organisation
            form.value.individual   = progression.data.individual
        },
        listeners    : {}
    }
}